export const bodyCss = {
  margin: "8px 0",

  "& > p": {
    margin: 0,
  },
};
